import { Tooltip } from 'bootstrap';

import { DropDownList } from '@syncfusion/ej2-dropdowns';

import { getControl } from '@/front/editable/state';

const CLIENT_RELATIONSHIP = 'Client';
const CLIENT_LIMIT_MESSAGE =
  'You have reached your client limit. Please change your plan or archive another client before adding a new Client.';

document.addEventListener('editablesReady', () => {
  for (const formElement of document.querySelectorAll('form[data-client-limit-remaining]')) {
    initClientLimitForm(formElement as HTMLFormElement);
  }
});

const initClientLimitForm = (form: HTMLFormElement) => {
  const relationshipEditable = form.querySelector('.editable[data-field="relationshipType"]') as HTMLElement | null;
  const saveButton = form.querySelector('[data-action="save"]') as HTMLAnchorElement | HTMLButtonElement | null;

  if (!relationshipEditable || !saveButton) {
    return;
  }

  const remainingLimit = parseInt(form.dataset.clientLimitRemaining ?? '', 10);

  if (Number.isNaN(remainingLimit) || remainingLimit > 0) {
    setSaveDisabled(saveButton, false);
    return;
  }

  const initialRelationship = getRelationshipValue(relationshipEditable);
  const modelId = (form.querySelector('#modelId') as HTMLInputElement | null)?.value;

  const refresh = () => {
    const relationship = getRelationshipValue(relationshipEditable);
    const consumesAdditionalSlot =
      relationship === CLIENT_RELATIONSHIP && (!modelId || initialRelationship !== CLIENT_RELATIONSHIP);

    setSaveDisabled(saveButton, consumesAdditionalSlot, CLIENT_LIMIT_MESSAGE);
  };

  const relationshipControl = getControl(relationshipEditable.id) as DropDownList | undefined;

  relationshipControl?.addEventListener('change', refresh);
  refresh();
};

const getRelationshipValue = (relationshipEditable: HTMLElement) => {
  const relationshipControl = getControl(relationshipEditable.id) as DropDownList | undefined;

  if (relationshipControl) {
    return relationshipControl.value?.toString() ?? '';
  }

  const input = relationshipEditable.querySelector('input[name="relationshipType"]') as HTMLInputElement | null;
  return input?.value ?? '';
};

const setSaveDisabled = (saveButton: HTMLAnchorElement | HTMLButtonElement, disabled: boolean, message?: string) => {
  if (disabled) {
    saveButton.dataset.disabled = 'true';
    saveButton.setAttribute('aria-disabled', 'true');
    if (message) {
      saveButton.setAttribute('title', message);
      saveButton.setAttribute('data-bs-toggle', 'tooltip');
      saveButton.setAttribute('data-bs-placement', 'left');
      Tooltip.getOrCreateInstance(saveButton);
    }
  } else {
    Tooltip.getInstance(saveButton)?.dispose();
    delete saveButton.dataset.disabled;
    saveButton.removeAttribute('aria-disabled');
    saveButton.removeAttribute('title');
    saveButton.removeAttribute('data-bs-toggle');
    saveButton.removeAttribute('data-bs-placement');
  }
};
